import React, {useEffect, useState} from "react";
import useJoystickStore from "../stores/useJoystickStore";
import {Directions} from "../utils/constants";

function JoystickSlices() {

    const direction = useJoystickStore(state => state.scrollDirection);
    const speed = useJoystickStore(state => state.scrollSpeed);

    const [opacity, setOpacity] = useState("0");

    useEffect(() => {
        let o = (speed + 1) * 0.25;
        setOpacity(o.toString())
    }, [speed]);

    const styles = ({
        path: {
            transition: "opacity 150ms linear"
        }
    });

    return (
        <div style={{width: "200px", height: "200px", transformOrigin: "100px 100px", transform: "rotate(-25deg)"}}>
            <svg xmlns="http://www.w3.org/2000/svg"
                 id="sv"
                 width="200"
                 height="200"
                 viewBox="0 0 300 300">
                <path id="UP" fill="#A4C950"
                      style={{opacity: direction === Directions.UP ? opacity : "0", ...styles.path}}
                      d="M150, 0 A150,150 0 0 1 264.90432919238253,53.57907315914984 L150,150 A0,0 0 0 0 150,150 Z"></path>
                <path id="UP_RIGHT" fill="#A4C950"
                      style={{opacity: direction === Directions.UP_RIGHT ? opacity : "0", ...styles.path}}
                      d="M264.90432919238253, 53.57907315914984 A150,150 0 0 1 299.9999998572106,149.99345501530712 L150,150 A0,0 0 0 0 150,150 Z"></path>
                <path id="RIGHT" fill="#A4C950"
                      style={{opacity: direction === Directions.RIGHT ? opacity : "0", ...styles.path}}
                      d="M299.9999998572106, 149.99345501530712 A150,150 0 0 1 246.4259403962356,264.9001219264001 L150,150 A0,0 0 0 0 150,150 Z"></path>
                <path id="DOWN_RIGHT" fill="#A4C950"
                      style={{opacity: direction === Directions.DOWN_RIGHT ? opacity : "0", ...styles.path}}
                      d="M246.4259403962356, 264.9001219264001 A150,150 0 0 1 150.01308996937328,299.99999942884233 L150,150 A0,0 0 0 0 150,150 Z"></path>
                <path id="DOWN" fill="#A4C950"
                      style={{opacity: direction === Directions.DOWN ? opacity : "0", ...styles.path}}
                      d="M150.01308996937328, 299.99999942884233 A150,150 0 0 1 35.104085558335996,246.43095376803979 L150,150 A0,0 0 0 0 150,150 Z"></path>
                <path id="DOWN_LEFT" fill="#A4C950"
                      style={{opacity: direction === Directions.DOWN_LEFT ? opacity : "0", ...styles.path}}
                      d="M35.104085558335996, 246.43095376803979 A150,150 0 0 1 0.0000012851047301865037,150.01963495402885 L150,150 A0,0 0 0 0 150,150 Z"></path>
                <path id="LEFT" fill="#A4C950"
                      style={{opacity: direction === Directions.LEFT ? opacity : "0", ...styles.path}}
                      d="M0.0000012851047301865037, 150.01963495402885 A150,150 0 0 1 53.564033043747116,35.108293261817636 L150,150 A0,0 0 0 0 150,150 Z"></path>
                <path id="UP_LEFT" fill="#A4C950"
                      style={{opacity: direction === Directions.UP_LEFT ? opacity : "0", ...styles.path}}
                      d="M53.564033043747116, 35.108293261817636 A150,150 0 0 1 149.9738200613531,0.000002284630625126738 L150,150 A0,0 0 0 0 150,150 Z"></path>
                <circle r="40" cx="150" cy="150" fill="#FFFFFF" />
            </svg>
        </div>
    );
}

export default JoystickSlices;